import React, { useState } from 'react'
import styled from 'styled-components'
import { IProblemFormData } from '../types/problemModal'
import { IProblemListItem } from '../../../../../modules/API/TeudotProblems/models/problems'
import DeleteIcon from '../../../../../generic/icons/IconLib/TrashIcon'
import SearchBlockWithTitle from '../../procedures/Q8/Layouts/SearchBlockWithTitle'
import SearchInput from '../../../../../generic/inputs/inputSearch'
import CircleActiveFilterBtn from '../../../../../generic/particles/CircleActiveFilterBtn'
import SearchProblem from './SearchProblem'
import ProblemInputFields from './ProblemInputFields'
import Disclaimer from './Disclaimer'
import ProblemCostSummary from './ProblemCostSummary'
import StatusReturningBadge from '../../drivers/Components/StatusReturningBadge'
import { getStatusColor } from '../hooks/useProblemHelpers'
import { ProblemDisclaimerText, IProblemCostResult } from '../utils/problemTypeUtils'
import CircleCheckbox from '../../../../../generic/ui/check-box/CircleCheckbox'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'

interface ProblemCardProps {
  problem: IProblemFormData
  index: number
  isOfficeUser: boolean
  filteredProblemTypes: IProblemListItem[]
  problemTypes: IProblemListItem[] | null
  checkStatus: (status: number) => boolean
  getProblemCostResult: (problem: IProblemFormData) => IProblemCostResult
  handleRemoveProblem: (id: string) => void
  getProblemDescription: (type: number) => string
  handleProblemChange: (id: string, field: keyof IProblemFormData, value: string | number | boolean) => void
}

const ProblemCard: React.FC<ProblemCardProps> = ({
  problem,
  index,
  isOfficeUser,
  filteredProblemTypes,
  problemTypes,
  checkStatus,
  getProblemCostResult,
  handleRemoveProblem,
  getProblemDescription,
  handleProblemChange,
}) => {
  const isExisting = problem.id.startsWith('existing-')
  const statusColor = problem.Status !== 0 ? getStatusColor(problem.Status) : undefined
  const disclaimerText = ProblemDisclaimerText(problem.Type)
  const [isAllowToSaveEmpty, setIsAllowToSaveEmpty] = useState(false)

  const handleAllowToSaveEmpty = (value: boolean) => {
    setIsAllowToSaveEmpty(value)
    handleProblemChange(problem.id, 'isAllowToSaveEmpty', value)
  }
  return (
    <ProblemSection $isExisting={isExisting} $statusColor={statusColor}>
      {problem.ProblemType === 3 && (
        <StatusReturningBadge status={problem.DriverStatus} />
      )}
      
      {isOfficeUser && (
        <ProblemCostSummary
          costResult={getProblemCostResult(problem)}
          index={index}
        />
      )}
      
      <SearchBlockWithTitle title="">
        {!checkStatus(problem.Status) && (
          <CircleActiveFilterBtn
            func={() => handleRemoveProblem(problem.id)}
            aria-label="מחק פניה"
            // tabIndex={0}
          >
            <DeleteIcon />
          </CircleActiveFilterBtn>
        )}
        
        {problem.Type > 0 ? (
          <SearchInput
            input={getProblemDescription(problem.Type)}
            setInput={() => {}}
            value={getProblemDescription(problem.Type)}
            iconHide
            size="full"
            disabled={true}
          />
        ) : (
          <SearchProblem
            list={filteredProblemTypes || []}
            defaultID={problem.Type}
            setProblemType={(value: React.SetStateAction<number>) => {
              const actualValue = typeof value === 'function' ? value(problem.Type) : value
              handleProblemChange(problem.id, 'Type', actualValue)
            }}
            required={problem.Type <= 0}
            disabled={isExisting}
          />
        )}
      </SearchBlockWithTitle>
      
      <ProblemInputFields
        problem={problem}
        problemTypes={problemTypes}
        onProblemChange={handleProblemChange}
        disabled={checkStatus(problem.Status)}
      />
      {
        problem.Type === 1 && (
          <TitleRow>
            <TitleRowItem
              name={
                <TitleRowItemWrapper>
                  <span>
                  סמן לזיכוי מלא
                  </span>
                  <CircleCheckbox
                    disabled={checkStatus(problem.Status)}
                    checked={isAllowToSaveEmpty}
                    onChange={(value: boolean) => handleAllowToSaveEmpty(value)}
                  />
                </TitleRowItemWrapper>
              }
              icon={<></>}
            />
          </TitleRow>
        )
      }
      {disclaimerText && <Disclaimer text={disclaimerText} />}
      
      <SearchBlockWithTitle title="הערה לפניה">
        <SearchInput
          input={problem.RemarkRequested}
          setInput={(value: string) => handleProblemChange(problem.id, 'RemarkRequested', value)}
          value="פרט את הפניה..."
          iconHide
          size="full"
          disabled={checkStatus(problem.Status)}
        />
      </SearchBlockWithTitle>
    </ProblemSection>
  )
}
const TitleRowItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
`
const ProblemSection = styled.div<{ $isExisting?: boolean; $statusColor?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: 15px;
  background: rgba(233, 240, 240, 0.1);
  border: 1px solid rgba(41, 127, 118, 0.1);

  ${props =>
    props.$isExisting &&
    `
    box-shadow: 0 2px 5px rgba(255, 99, 71, 0.3);
    border: 2px solid rgba(255, 99, 71, 0.1);
  `}

  ${props =>
    props.$statusColor &&
    `
    box-shadow: 0 2px 5px ${props.$statusColor};
    border: 2px solid ${props.$statusColor};
  `}
`

export default ProblemCard

